import {AnyAction} from 'redux'
import {
  CommonErrorPayloadFormatType,
  RejectResponseType
} from 'types/errorResponse'

import {ErrorResponse} from '@vio/core/src/booking/types/ErrorResponse'
import {SearchApiError} from '@vio/core/src/sapi/services/searchApi'
import {FetchBaseQueryError} from '@vio/core/src/utils/network/fetchBaseQuery'
export const ERROR = 'ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'

export type ErrorActionType = {
  error: CommonErrorPayloadFormatType
  type: typeof ERROR | typeof CLEAR_ERROR
}

export type ActionType = ErrorActionType

export const error = (error: CommonErrorPayloadFormatType) => ({
  type: ERROR,
  error
})

export const clearError = () => ({
  type: CLEAR_ERROR
})

export const toCommonErrorPayloadFormat = (
  action: {type: string},
  error: RejectResponseType
): CommonErrorPayloadFormatType => ({
  originalErrorAction: action?.type,
  errorResponse: error?.data,
  statusCode: error?.status,
  value: {
    statusCode: error?.status,
    params: error?.config?.params,
    headers: error?.config?.headers || {},
    url: error?.config?.url || '',
    method: error?.config?.method || '',
    errorResponse: error?.data
  }
})
const formatSapiRtqErrorResponse = (
  data: SearchApiError | undefined
): ErrorResponse => ({
  message: 'sapi failed to load',
  details: {recoverable: true},
  type: data
})

/**
 * Normalizes a rejected RTK Query mutation payload. Unlike
 * `rtqResponseWithErrorDataToRejectResponse` it keeps the HTTP status, which
 * `getErrorContext` reports as the error code.
 */
export const rtqRejectionToRejectResponse = (
  payload?: FetchBaseQueryError
): RejectResponseType => ({
  status: payload?.status,
  // fetchBaseQuery puts the raw network-error text straight into `data`
  data:
    typeof payload?.data === 'string'
      ? {message: payload.data, details: {}}
      : (payload?.data ?? {details: {}}),
  headers: payload?.headers ?? {},
  config: {},
  request: {},
  statusText: ''
})

export const rtqResponseWithErrorDataToRejectResponse = (
  error?: ErrorResponse
): RejectResponseType => ({
  status: undefined,
  data: {
    type: error?.type,
    details: error?.details || {},
    message: error?.message
  },
  config: {},
  headers: {},
  request: {},
  statusText: error?.message || ''
})

export const sapiRtkQueryErrorToCommonErrorPayloadFormat = (
  action: AnyAction
): CommonErrorPayloadFormatType => ({
  originalErrorAction: action?.type,
  errorResponse: formatSapiRtqErrorResponse(action?.payload),
  statusCode: action?.payload?.status,
  value: {
    ...action?.meta?.arg?.originalArgs,
    statusCode: action?.payload?.status,
    errorResponse: action?.payload?.data
  }
})
